
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
// import { toast } from "react-toastify";
import { decryptconfigdata } from "../../../../utils/utils";
import Select from "react-select";
import Cookies from "js-cookie";
import { storeLead } from "./actions/StoreLeadAction";
import toast from "react-hot-toast";

const CreateLeadModal = ({ showModal, setShowModal, productData }) => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [apiUrl, setApiUrl] = useState("");
  const [subdomain, setSubdomain] = useState("");
  const [formData, setFormData] = useState({
    customerName: "",
    companyName: "",
    phoneNumber: "",
    emailId: "",
    products: [],
  });

  useEffect(() => {
    const decryptedApiUrl = decryptconfigdata("apiUrl");
    setApiUrl(decryptedApiUrl);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Perform full form validation
      const isValidForm = await validateForm(); // validateForm sets the errors state internally
      console.log("Selected Products Array:", formData.products);
      console.log("Form Submitted:", formData);

      if (!isValidForm) {
        console.log("Form is incomplete or there are errors:", errors);
        setIsLoading(false); // Stop loading if validation fails
        return; // Exit the form submission process
      }

      const data = {
        name: formData.customerName,
        company_name: formData.companyName,
        phone_number: formData.phoneNumber,
        email: formData.emailId,
        associated_products: formData.products,
        lead_source: "manual",
      };

      const response = await storeLead(data);
      if (response.success) {
        toast.success("Lead created successfully!");

        setFormData({
          customerName: "",
          companyName: "",
          phoneNumber: "",
          emailId: "",
          products: [],
        });
        setErrors({});
      } else {
        toast.error(
          "An error occurred while processing your request. Please try again!"
        );
      }
    } catch (error) {
      toast.error(
        "An error occurred while processing your request. Please try again!"
      );
    } finally {
      setIsLoading(false); // Ensure loading state is reset
    }
  };

  const validateForm = () => {
    const { customerName, companyName, phoneNumber, emailId, products } =
      formData;
    const validationErrors = {};

    if (!customerName.trim())
      validationErrors.customerName = "Please enter your name";
    if (!companyName.trim())
      validationErrors.companyName = "Please enter company name";
    if (!phoneNumber.trim())
      validationErrors.phoneNumber = "Please enter your phone number";
    if (!emailId.trim())
      validationErrors.emailId = "Please enter your email address";
    // if (!products || products.length === 0)
    //   validationErrors.products = "Please select at least one product";

    if (emailId && emailId.trim() && !emailPattern.test(emailId)) {
      validationErrors.emailId = "Please enter a valid email address";
    }

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const closeModal = () => {
    setShowModal(false);
    setFormData({
      customerName: "",
      companyName: "",
      phoneNumber: "",
      emailId: "",
      products: [],
    });
  };

  const handleEmailValidation = async () => {
    if (!emailValidation()) {
      await validateEmail();
    }
  };

  const emailValidation = () => {
    if (!emailPattern.test(formData.emailId)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        emailId: "Email is invalid!",
      }));
      return true;
    }
    return false;
  };

  const validateEmail = async () => {
    const error = { ...errors }; // Preserve existing errors
    if (!formData.emailId) {
      error.emailId = "Email is required!";
    } else {
      await checkEmail(error, () => {});
    }
    setErrors(error);
    return Object.keys(error).length > 0;
  };

  const phoneValidation = () => {
    const phonePattern =
      /^((\d{1,3}\(?\d\)?\d{1,5})|(\(?\d{3,6}\)?))(\d{3,7})?(( x| ext)\d{1,5}){0,1}$/;

    if (!phonePattern.test(formData.phoneNumber)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phoneNumber: "Phone number is invalid! Must be digits.",
      }));
      return true;
    }
    return false;
  };

  const checkEmail = async (error, callback) => {
    try {
      setIsLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_CRM}/crm/check-email`,
        {
          method: "POST",
          body: JSON.stringify({ email: formData.emailId }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const res = await response.json();

      if (res && res.code != 200) {
        console.log("Email validation response:", res);
        error.emailId = res.message || "An error occurred. Please try again.";
        callback(false);
      } else {
        delete error.emailId;
        callback(true);
      }
    } catch (err) {
      console.error("Error validating email:", err);
      error.emailId = "An unexpected error occurred. Please try again.";
      callback(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      if (name === "customerName") {
        updatedData.companyName = value
          .replace(/[^a-zA-Z0-9-]+/g, "-")
          .replace(/(^-+|-+$)/g, ""); // Auto-filling companyName from customerName
      }

      return updatedData;
    });

    // Clear errors for the field being changed
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      // If the customerName is updated, also clear the companyName error
      if (name === "customerName") {
        delete updatedErrors.companyName; // Clear companyName error if customerName changes
      }

      return updatedErrors;
    });
  };

  const handleProductChange = (selectedOptions) => {
    // TODO: Check if we need to limit the selection to 3 products
    const MAX_SELECTION = 3;
    // Check for the max selection limit
    if (selectedOptions.length > MAX_SELECTION) {
      alert("You can select up to 3 products only.");
      return;
    }

    let newOption = null;
    if (selectedOptions.length > selectedProducts.length) {
      newOption = selectedOptions.find(
        (option) =>
          !selectedProducts.some((selected) => selected.value === option.value)
      );
    }

    // Update the state
    setSelectedProducts(selectedOptions);

    // Clear the error for the products field if the selection is valid
    const updatedErrors = { ...errors };
    if (selectedOptions.length > 0) {
      delete updatedErrors.products; // Remove the error message for products
    }

    setFormData((prevState) => ({
      ...prevState,
      products: selectedOptions.map((option) => option.value),
    }));

    setErrors(updatedErrors); // Update the errors state
  };

  const renderInput = (name, label, type = "text", placeholder) => {
    return (
      <div className="my-3 w-100">
        <label
          className="form-label"
          style={{ fontSize: "13px", fontWeight: "400", marginBottom: "5px" }}
        >
          {label}
        </label>
        <input
          type={type}
          name={name}
          placeholder={placeholder}
          className="form-control w-100"
          style={{
            fontSize: "13px",
            borderRadius: "6px",
            padding: "10px",
            borderColor: "#ccc",
            marginBottom: "5px",
            fontWeight: "300",
          }}
          value={(formData && formData[name] && formData[name]) || ""}
          onChange={handleChange}
          onBlur={
            type === "email"
              ? handleEmailValidation
              : name === "phoneNumber"
              ? phoneValidation
              : undefined
          }
          autoComplete="off"
        />
        {errors[name] && <span style={{ color: "red" }}>{errors[name]}</span>}
      </div>
    );
  };

  return (
    <Modal show={showModal} onHide={closeModal}>
      <Modal.Header>
        <Modal.Title>
          <span>Create New Lead</span>
          {/* Close Button */}
          <button
            type="button"
            onClick={closeModal}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "none",
              border: "none",
              fontSize: "16px",
              cursor: "pointer",
              color: "#333",
            }}
            aria-label="Close"
          >
            ✖
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit={handleSubmit}
          style={{ width: "100%", height: "100%", position: "relative" }}
          autoComplete="off"
        >
          {/* Name Input */}
          {renderInput("customerName", "Name", "text", "Name")}

          {/* Company Name Input */}
          {renderInput("companyName", "Company Name", "text", "Name")}

          {/* Phone Number Input */}
          {renderInput("phoneNumber", "Phone Number", "text", "Phone number")}

          {/* Email ID Input */}
          {renderInput("emailId", "Email ID", "email", "Email ID")}

          {/* Products Select */}
          <div className="my-4 w-100">
            <label
              className="form-label"
              style={{
                fontSize: "13px",
                fontWeight: "400",
                lineHeight: "20px",
                color: "#666666",
                marginBottom: "5px",
              }}
            >
              Products
            </label>
            <Select
              isMulti
              options={productData}
              value={selectedProducts}
              onChange={handleProductChange}
              placeholder="Select up to 3 products..."
              className="w-100"
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: "6px",
                  padding: "5px",
                  borderColor: "#ccc",
                  fontSize: "13px",
                  marginBottom: "5px",
                  fontWeight: "300",
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                }),
                menu: (base) => ({
                  ...base,
                  borderRadius: "6px",
                }),
              }}
            />
            {errors.products && (
              <span
                className="error"
                style={{ color: "red", fontSize: "12px" }}
              >
                {errors.products}
              </span>
            )}
          </div>

          {/* Submit Button */}
          <div
            className="d-flex align-items-center"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              marginTop: "15px",
            }}
          >
            <button
              type="submit"
              className="btn btn-primary"
              style={{
                // backgroundColor: false ? "#a6d6f4" : "#52b7ed",
                color: "#fff",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "bold",
                padding: "10px 20px",
                border: "none",
                cursor:
                  isLoading || Object.keys(errors).length > 0
                    ? "not-allowed"
                    : "pointer",
              }}
              disabled={isLoading || Object.keys(errors).length > 0}
            >
              {isLoading ? "Loading..." : "Create Lead"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateLeadModal;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/CreateLeadModal.js